export type storageKeyType = 'localStorage' | 'sessionStorage';
export namespace BrowserStorage {
    export function eraseCookie(name: string) {
        document.cookie = `${name}=; Max-Age=-99999999;`;
    }

    export function setCookie(name: string, value: string, daysOrDate: number | Date) {
        let expires = '';
        if (daysOrDate) {
            const expirationDate =
                typeof daysOrDate === 'number'
                    ? new Date(Date.now() + daysOrDate * 24 * 60 * 60 * 1000)
                    : daysOrDate;
            expires = `; expires=${expirationDate.toUTCString()}`;
        }
        document.cookie = `${name}=${value || ''}${expires};path=/`;
    }

    export function getCookie(name: string) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }

        return null;
    }

    export function getItem(key: string, storageKey: storageKeyType = 'localStorage') {
        try {
            if (window[storageKey].getItem(key) !== null) {
                return window[storageKey].getItem(key);
            }
        } catch (e) {
            console.error(e);

            return getCookie(key);
        }
    }

    export function setItem(
        key: string,
        value: string,
        storageKey: storageKeyType = 'localStorage'
    ) {
        try {
            window[storageKey].setItem(key, value);
        } catch (e) {
            console.error(e);
            setCookie(key, value, 20);
        }
    }

    export function removeItem(key: string, storageKey: storageKeyType = 'localStorage') {
        try {
            window[storageKey].removeItem(key);
        } catch (e) {
            console.error(e);
            eraseCookie(key);
        }
    }

    export function storagePolling(key: string, callBack: Function) {
        let storageValue = getItem(key);

        const checkForKeyChange = () => {
            const latestValue = getItem(key);

            if (storageValue !== latestValue) {
                storageValue = latestValue;
                callBack(latestValue);
            }
        };

        return setInterval(checkForKeyChange, 2000);
    }
}
